var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4012 1.59879L4.55118 7.44881C4.32613 7.67381 4.19971 7.97909 4.19971 8.29733V9.60029C4.19971 9.93161 4.46834 10.2003 4.79971 10.2003H6.10267C6.42091 10.2003 6.72613 10.0739 6.95119 9.84881L12.8012 3.99879C13.2698 3.53016 13.2698 2.77036 12.8012 2.30173L12.0982 1.59879C11.6296 1.13016 10.8698 1.13016 10.4012 1.59879ZM6.31477 9.21239C6.25855 9.26867 6.18223 9.30029 6.10267 9.30029C5.54875 9.30029 5.09971 8.85125 5.09971 8.29733C5.09971 8.21777 5.13131 8.14145 5.18758 8.08517L11.0375 2.23518C11.1547 2.11802 11.3447 2.11803 11.4619 2.23518L12.1648 2.93813C12.2819 3.05528 12.2819 3.24523 12.1648 3.36239L6.31477 9.21239Z",
    fill: "url(#paint0_linear_0_2337)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99971 2.24956C5.99971 2.49809 5.79823 2.69957 5.54971 2.69957H2.39971C2.23402 2.69957 2.09971 2.83388 2.09971 2.99957V11.9996C2.09971 12.1653 2.23402 12.2996 2.39971 12.2996H11.3997C11.5654 12.2996 11.6997 12.1653 11.6997 11.9996V8.8496C11.6997 8.60102 11.9012 8.3996 12.1497 8.3996C12.3982 8.3996 12.5997 8.60102 12.5997 8.8496V11.9996C12.5997 12.6623 12.0625 13.1996 11.3997 13.1996H2.39971C1.73697 13.1996 1.19971 12.6623 1.19971 11.9996V2.99957C1.19971 2.33682 1.73697 1.79956 2.39971 1.79956H5.54971C5.79823 1.79956 5.99971 2.00103 5.99971 2.24956Z",
    fill: "url(#paint1_linear_0_2337)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_2337",
    x1: 8.67617,
    y1: 1.24731,
    x2: 8.67617,
    y2: 10.2003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_2337",
    x1: 6.89971,
    y1: 1.79956,
    x2: 6.89971,
    y2: 13.1996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit_pen.ba9b0c05afe828df55bed79e5e723af5.svg";
export { ForwardRef as ReactComponent };